import nativeRedirect from "@workspace/casino_pages/legacyLayer/shared/utils/router/nativeRedirect";
import { useCallback, useEffect, useState } from "react";
import getNotificationArticle from "@/actions/notifications/getNotificationArticle";
import handleMarkAsRead from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/graphql/handleMarkAsRead";
import useClaimNftReward from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/NftRewardNotification/hooks/useClaimNftReward";
import useMyBonusOffersNftLink from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/NftRewardNotification/hooks/useMyBonusOffersNftLink";

type Props = {
  notification: NotificationProps;
  context: WorkerContext;
  onClose: () => void;
};

const useNftRewardNotification = ({
  onClose,
  notification,
  context,
}: Props) => {
  const [content, setContent] = useState<string | null>(null);

  const { bonusOfferId } = useMyBonusOffersNftLink(context);
  const { handleClaimNftReward } = useClaimNftReward();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const mainBlock = await getNotificationArticle({
        language: context.language,
        section: notification.normalNotification?.articleSection,
        handle: notification.normalNotification?.articleHandle,
      });
      if (mainBlock) {
        setContent(mainBlock);
      }
    };
    fetchData();
  }, [notification, context]);

  const handleClick = useCallback(async () => {
    setLoading(true);
    await handleMarkAsRead(notification.normalNotification);
    await handleClaimNftReward(bonusOfferId ?? "");
    nativeRedirect("/profile/rewards", context.language, context.language);
    setLoading(false);
    onClose();
  }, [
    notification.normalNotification,
    handleClaimNftReward,
    bonusOfferId,
    context.language,
    onClose,
  ]);

  const handleClose = useCallback(async () => {
    await handleMarkAsRead(notification.normalNotification);
    onClose();
  }, [notification.normalNotification, onClose]);

  return {
    content,
    handleClick,
    handleClose,
    loading,
    bonusOfferId,
  };
};

export default useNftRewardNotification;
